import styled from "styled-components"

export const StyledNavbar = styled.div`
  width: 100%;
  background-color: #007a99;

  & > img {
  margin: 0.5rem 0 0.5rem 1rem;
  }
`